/**
 * ACTIVITY-CORE (L2) — Trash: generic chrome for soft-deleted entities.
 *
 * The domain (restorable entities) is provided by the specific app; until it
 * exists, the trash displays its empty state. Local-first: when entities exist,
 * they will operate on the account SQLite via the normal write-path.
 */
import { msg } from "@lingui/core/macro";
import { Trash2 } from "@fleet/icons";
import { useI18n } from "@/providers/i18n-provider";
import { EmptyState } from "@/components/ui/empty-state";

export function TrashView() {
  const { t } = useI18n();

  return (
    <div class="space-y-6" data-testid="trash-page">
      <div class="flex items-center gap-3">
        <div class="flex h-10 w-10 items-center justify-center rounded-xl bg-primary/10 text-primary">
          <Trash2 class="h-5 w-5" />
        </div>
        <div>
          <h1 class="text-2xl font-bold tracking-tight">{t(msg`Trash`)}</h1>
          <p class="text-sm text-muted-foreground">
            {t(msg`Deleted items. Restore them or delete them forever.`)}
          </p>
        </div>
      </div>

      <EmptyState
        icon={Trash2}
        title={t(msg`Trash is empty`)}
        description={t(msg`Deleted items will wait here until you restore them.`)}
      />
    </div>
  );
}
